"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkboxFilter = checkboxFilter;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const BaseFilter_1 = require("./BaseFilter");
const inputs_1 = require("../../inputs");
/**
 * Provides a two-state "on/off" filter.
 *
 * By default the on/off values are `on === true` and `off === undefined`.
 *
 * You can flip the on/off values by passing `onValue: false`, in which case
 * `on === false` and off === undefined`.
 *
 * Or you can set on/off directly, by passing both `onValue` and `offValue`, even to
 * non-boolean values, i.e. `onValue: "foo", offValue: "bar"`.
 */
function checkboxFilter(props) {
    return (key) => new CheckboxFilter(key, {
        // If the user has set the offValue, that should be the default b/c we're only a two-state
        defaultValue: props.offValue,
        ...props,
    });
}
class CheckboxFilter extends BaseFilter_1.BaseFilter {
    render(value, setValue, tid, inModal, vertical) {
        const { defaultValue, onValue = true, offValue = undefined, ...props } = this.props;
        return ((0, jsx_runtime_1.jsx)(inputs_1.Checkbox, { ...props, selected: value === undefined ? false : value === onValue, label: this.label, onChange: (on) => {
                setValue(on ? onValue : offValue);
            }, ...this.testId(tid) }));
    }
    get hideLabelInModal() {
        return true;
    }
}
